<template>
  <div>
    <v-dialog v-model="showAllPhotosDialog" width="800" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
          <v-card-title class="headline grey lighten-3">
            <v-layout align-center>
              <v-flex grow>
                All Photos
              </v-flex>
              <v-spacer />
              <v-btn flat icon class="align--right" @click.stop="close()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md class="px-0">
              <v-layout row wrap>
                  <v-flex
                    v-for="(img, key) in images"
                    :key="key"
                    xs3
                  >
                    <div class="inspection__area-image">
                      <v-img
                        class="elevation-2"
                        :src="img"
                        aspect-ratio="1"
                        @click="openGallery(key)"
                      />
                      <v-btn
                        class="delete-btn"
                        x-small
                        icon
                        color="warning"
                      >
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div ref="areaGallery" class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="pswp__bg"></div>
      <div class="pswp__scroll-wrap">
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
              <div class="pswp__counter"></div>
              <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
              <button class="pswp__button pswp__button--share" title="Share"></button>
              <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
              <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
              <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                  <div class="pswp__preloader__cut">
                    <div class="pswp__preloader__donut"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
            <div class="pswp__caption">
              <div class="pswp__caption__center"></div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import config from '@/config'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default'

export default {
  name: 'InspectionAllPhotos',
  props: {
    showAllPhotosDialog: {
      type: Boolean,
      default: false,
      required: true
    },
    images: {
      type: Array,
      required: true
    },
  },
  computed: {
    // areas() {
    //   const inspection = this.$store.getters['HouseList/Inspections/getSelected']
    //   return Object.values(inspection).reduce((acc, room) => {
    //     if (typeof acc === 'undefined') {
    //       acc = []
    //     }

    //     console.log('acc.push()', ...Object.values(room.areas));
    //     acc.push(...Object.values(room.areas))
    //     return acc
    //   }, [])
    // },
    // inspection() {
    //   const insp = this.$store.getters['HouseList/Inspections/getSelected']
    //   const rooms = Object.values(insp);
    //   if (rooms.length === 0) {
    //     return {
    //       house_id: '',
    //       date: ''
    //     }
    //   }
    //   const room = rooms[0];
    //   return {
    //     house_id: room.house_id,
    //     date: moment.unix(room.timestamp).format("YYYY-MM-DD")
    //   }
    // },
  },
  methods: {
    ...mapActions({
      upload: 'HouseList/Inspections/upload'
    }),
    close() {
      this.$emit('update:showAllPhotosDialog', false)
    },
    openGallery(index) {
      const images = this.images.map((src) => {
        return {
          src: src,
          w: 1024,
          h: 768,
        }
      })

      if (images.length > 0) {
        const gallery = new PhotoSwipe(
          this.$refs.areaGallery,
          PhotoSwipeDefaultUI,
          images,
          { index }
        )
        gallery.init()
      }
    },
    // deleteImage(area, index) {
    //   area.img.splice(index, 1)
    //   this.upload({
    //     file: null,
    //     area: area,
    //   })
    // }
  }
}
</script>
<style lang="stylus" scoped>
.inspection__area-image .v-image {
  cursor: pointer;
}

.inspection__area-image {
  position: relative;
}

.inspection__area-image .v-btn {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
}

.delete-btn {
	opacity: 0.25;
}

.delete-btn:hover {
  filter: brightness(80%);
  opacity: 0.99;
}
</style>
